module.exports = __webpack_public_path__ + "img/no1.30bf505.png";